export const closedTicketStatuses = ['closed'];
